import React, {useEffect, useMemo} from "react";
import {
    useActiveProjectSelector,
    useCpmCompleteSelector,
    useProjectViewSelector,
} from "../../../../store/selectors/project.selectors";
import {
    useAllTaskListSelector,
    useTaskListLoadProjectIdSelector
} from "../../../../store/selectors/task/task.selectors";
import {Dimmer, Loader} from "semantic-ui-react";
import {TaskList} from "./components/TaskList";
import FirebaseProjectFunctions from "../../../../firebase/firebase-functions/project-service";
import { useDispatch } from 'react-redux';
import * as projectActions from "../../../../store/actions/project.actions";
import * as taskActions from "../../../../store/actions/task.actions";
import FirebaseUsage from "../../../../firebase/firebase.usage";
import {useUserSelector} from "../../../../store/selectors/authorization.selectors";
import {useProjectMemberListSelector} from "../../../../store/selectors/team.selectors";
import {COLLECTIONS} from "../../../../firebase/constants";
import QualityPage from "../QualityPage/QualityPage";
import GanttChart from "../../components/GanttChart/GanttChart";
import {matchPath} from "react-router-dom";
import {SearchActions} from "../../../../store/actions/search.actions";
import {SprintTaskList} from "./components/SprintTaskList";
import ChangeAnalysisPage from "../ChangeAnalysisPage/ChangeAnalysisPage";
import {subsManager} from "../../../../store/middleware/subs-manager/subs-manager";
import CheckListPage from "../ChecklistPage/ChecklistPage";
import { trefoil } from 'ldrs'
import TaskModel from "../../../../models/responses/task.model";
import RiskTable from "../../components/RiskTable/RiskTable";
trefoil.register()

const getTaskByCode = (allTasks: Map<string, TaskModel>, taskCode: string) => {
    let foundTask: any = null;
    allTasks.forEach((task) => {
        if (task.task_code === taskCode) {
            foundTask = task;
        }
    });
    return foundTask;
}

const FlowPage: React.FC = () => {
    const activeProject = useActiveProjectSelector();
    const [oldActiveProject, setOldActiveProject]: any = React.useState(null);
    const cpmFinished = useCpmCompleteSelector()
    const dispatch = useDispatch();
    const user = useUserSelector()
    const projectMembersList = useProjectMemberListSelector();
    const projectView = useProjectViewSelector();
    const allTasks = useAllTaskListSelector();
    const [pageLoaded, setPageLoaded] = React.useState<any>(0);
    const taskListLoadProjetId = useTaskListLoadProjectIdSelector();

    useEffect(() => {
        if (allTasks.size > 0 && activeProject && activeProject.projectId !== oldActiveProject && activeProject.projectId === taskListLoadProjetId) {
            let cpmRefresh = true;
            console.log("running CPM on load")
            FirebaseProjectFunctions.fullCPMCalc(
                    activeProject.projectId,
                    "false",
                    dispatch,
                    cpmRefresh,
                    activeProject.frozenDate ? Math.floor(activeProject.frozenDate.seconds / 86400) * 86400 : null
                )
                .then(() => {
                    console.log("cpm run on load - successful")
                    if (activeProject.clientId) subsManager.subscribeChecklists(activeProject.clientId);
                    dispatch(projectActions.Actions.setCpmComplete(true))
                    if (user && projectMembersList) {
                        const member = projectMembersList.find((member) => member.userId === user.userId)
                        const memberId = member!.memberId
                        FirebaseUsage.updateDoc(COLLECTIONS.PROJECT_MEMBERS, memberId, {
                            lastViewed: FirebaseUsage.timestamp(),
                            totalViews: member!.totalViews ? member!.totalViews + 1 : 1,
                            live: true
                        }).then(() => subsManager.subscribeProjectPermission(user!.userId))
                            .catch((err) => console.log(err))
                    }
                    const matchPathname = matchPath( {path: '/:projectId/flow/:task_id'}, window.location.pathname);
                    const params: any = matchPathname
                        ? matchPathname.params
                        : {};
                    const taskId = params.task_id;
                    if (taskId) {
                        const task = allTasks.get(taskId);
                        if (task) {
                            dispatch(taskActions.Actions.setActiveTask(task));
                            dispatch(SearchActions.addChip([{ type: "filter", text: task.task_code }]));
                            dispatch(projectActions.Actions.setLedgerOpen(true));
                        }
                        else {
                            const taskByCode = getTaskByCode(allTasks, taskId);
                            if (taskByCode) {
                                dispatch(taskActions.Actions.setActiveTask(taskByCode));
                                dispatch(SearchActions.addChip([{type: "filter", text: taskByCode.task_code}]));
                                dispatch(projectActions.Actions.setLedgerOpen(true));
                            }
                        }
                    }
                })
                .catch((err) => console.log("cpm run on load unsuccessful - ", err))
            setOldActiveProject(activeProject.projectId);
        }
    }, [allTasks, taskListLoadProjetId]);

    useEffect(() => {
        const flowPageDocument = document.getElementById('flow-page-id');
        if (flowPageDocument) {
            // add event to trigger if width of document changes
            dispatch(projectActions.Actions.setViewWidth(flowPageDocument.clientWidth));
        } else {
            setTimeout(() => setPageLoaded(prevState => prevState + 1), 0)
        }
    }, [pageLoaded]);

    const renderComponent = useMemo(() =>
        <div className="flow-page-container" id="flow-page-id">
            {projectView === "task" ? <TaskList/> :
                projectView === "quality" ? <QualityPage/> :
                    projectView === "gantt" ? <GanttChart/> :
                        projectView === "sprint" ? <SprintTaskList/> :
                            projectView === "change" ? <ChangeAnalysisPage/> :
                                projectView === "checklists" ? <CheckListPage /> :
                                    projectView === "risks" ? <RiskTable /> :
                                    <TaskList/>
            }
        </div>, [projectView]);

    return cpmFinished && activeProject && !activeProject.quarantined ? (
        renderComponent
    ) : (
        <div className="flow-page-container" id="flow-page-id">
            <Dimmer active>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh"}}>
                    <l-trefoil
                        size="60"
                        stroke="4"
                        stroke-length="0.15"
                        bg-opacity="0.1"
                        speed="1.4"
                        color="white"
                    ></l-trefoil>
                    <h4>{
                        activeProject ? !activeProject.quarantined ?
                            "Project data loading..." :
                            "A member of your team is project is updating this project. Please wait until this has been completed before returning to the project." :
                            "Project data loading..."
                    }</h4>
                </div>
            </Dimmer>
        </div>
    )
};

export default FlowPage;
